"use client";

import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Impressum() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="176134" id="unternehmensinformationen" className="bg-background pt-[160px] pb-32 px-6 md:px-12">
      <div ref={ref} className={`max-w-[800px] mx-auto bg-card border border-border rounded-[24px] p-8 md:p-16 shadow-sm transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h1 className="text-foreground font-default text-4xl md:text-5xl mb-12 md:mb-16">
          Unternehmensinformationen
        </h1>

        <div className="text-foreground font-sans text-lg leading-[2.0] space-y-16">
          
          <div>
            <h2 className="text-xl font-default font-semibold mb-4 text-foreground">
              Anbieter
            </h2>
            <p className="m-0 font-sans !font-medium">BLUVIT GmbH
<div>Obergarten 22
</div><div>34253 Lohfelden
</div><div>Deutschland</div></p>
          </div>

          <div className="flex flex-col gap-2">
            <h2 className="text-xl font-default font-semibold mb-2 text-foreground">
              Kontakt
            </h2>
            <div className="flex flex-col font-sans">
              <span>
                Telefon:{" "}
                <Link to="tel:+493012345678" className="text-primary hover:text-primary transition-all underline-offset-4">+49 561 9402 6666</Link>
              </span>
              <span>
                E-Mail:{" "}
                <Link to="mailto:hello@coworking-hub.de" className="text-primary hover:text-primary transition-all underline-offset-4">info@bluvit.de</Link>
              </span>
            </div>
          </div>

          <div>
            <h2 className="text-xl font-default font-semibold mb-4 text-foreground">
              Geschäftsführer:
            </h2>
            <p className="m-0 font-sans">Timm Vollmer</p>
          </div>
          
          <div>
            <h2 className="text-xl font-default font-semibold mb-4 text-foreground">
              Register & Steuern
            </h2>
            <p className="m-0 font-sans">Handelsregister: Amtsgericht Kassel, HRB 18250 Umsatzsteuer-Identifikationsnummer gemäß § 27 a UStG: DE 329883065 Wirtschafts-Identifikationsnummer gemäß § 139c Abgabenordnung:&nbsp; DE 329883065</p>
          </div>

          <div>
            <h2 className="text-xl font-default font-semibold mb-4 text-foreground">
              Rechtliche Hinweise
            </h2>
            <p className="m-0 font-sans">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit, die Sie unter https://ec.europa.eu/consumers/odr finden. Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </div>

        </div>
      </div>
    </section>;
}